import React from 'react';
import styles from '../styles/ConfirmDialog.module.css';

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
  tone = 'default',
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} role="presentation">
      <div className={styles.dialog} role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <div className={styles.header}>
          <div className={`${styles.iconWrap} ${tone === 'danger' ? styles.iconDanger : styles.iconDefault}`}>
            <i className="bi bi-question-circle" aria-hidden="true"></i>
          </div>
          <h3 id="confirm-dialog-title" className={styles.title}>{title}</h3>
        </div>

        <p className={styles.message}>{message}</p>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel} disabled={loading}>
            {cancelText}
          </button>
          <button
            type="button"
            className={`${styles.confirmBtn} ${tone === 'danger' ? styles.confirmDanger : ''}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
